import { render, staticRenderFns } from "./agentBgdRecharge.vue?vue&type=template&id=1f4b009a&scoped=true&"
import script from "./agentBgdRecharge.vue?vue&type=script&lang=js&"
export * from "./agentBgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b009a",
  null
  
)

export default component.exports